module.exports = __webpack_public_path__ + "img/mahsulot-1.9446a256.png";